import React from 'react';
import './css/Thumbnail.css';

class PostThumbnail extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      imgLength: null,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth
    };
    this.imageAspectRatio = this.imageAspectRatio.bind(this);
    this.updateWindowSize = this.updateWindowSize.bind(this);

    window.addEventListener("resize", this.updateWindowSize);
  }

  componentWillMount() {
    if(this.props.post.fields.imageGallery != null){
      this.setState({
        imgLength: this.props.post.fields.imageGallery.length
      })
    }
  }

  //WINDOW HEIGHT 
   updateWindowSize() {
      this.setState({ windowHeight: window.innerHeight, windowWidth:window.innerWidth });
  }
  //IMAGE ASPECT RATIO 
  imageAspectRatio(image){
    let bgColor;
    if(image.fields.backgroundColour !== undefined || image.fields.backgroundColour !== null) {
      bgColor = image.fields.backgroundColour;
    } else {
      bgColor = 'none'
    }
    if((this.state.windowHeight * 0.7) * (image.fields.featuredImage.fields.file.details.image.width / image.fields.featuredImage.fields.file.details.image.height) < (this.state.windowWidth*0.8)) {
      return {
        width: (this.state.windowHeight * 0.7) * (image.fields.featuredImage.fields.file.details.image.width / image.fields.featuredImage.fields.file.details.image.height) + "px",
        height: (this.state.windowHeight * 0.7) + "px",
        background: bgColor
      }
    } else {
      return {
        width: (this.state.windowWidth * 0.55) * (image.fields.featuredImage.fields.file.details.image.width / image.fields.featuredImage.fields.file.details.image.height) + "px",
        height: (this.state.windowWidth * 0.55) + "px",
        background: bgColor
      }  
    }
  }   

  render() {
    const resizedImage = this.props.post.fields.featuredImage.fields.file.url+'?q=90&w=1800';
    const smlimage = this.props.post.fields.featuredImage.fields.file.url+'?q=1&w=10';
    return (
      <div className="post" style={this.imageAspectRatio(this.props.post)}>
        <img className="carousel-cell-image" src={smlimage} data-flickity-lazyload-src={resizedImage} alt={this.props.post.fields.featuredImage.fields.file.title}/>
      </div>
    )
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }
}
export default PostThumbnail;


// WEBPACK FOOTER //
// ./src/PostThumbnail.js